import {Checkbox as MantineCheckbox} from '@mantine/core';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export enum CheckboxSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
}

export interface CheckboxProps {
  checked: boolean;
  'aria-labelledby'?: string;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  size?: CheckboxSize;
  dataTestAttrs?: DataTestAttrs;
}

/**
 * Renders a 16x16 checkbox.
 *
 * This component is controlled, so the caller should handle updating the `checked` prop when `onChange` is
 * called.
 *
 * @example
 * function Example() {
 *   const [checked, setChecked] = useState(false);
 *
 *   return (
 *     <Checkbox checked={checked} onChange={() => setChecked(!checked)} />
 *   );
 * }
 * @deprecated - These checkboxes are unlabeled and shouldn't be used in new code. Prefer CheckboxInput.
 */
export default function Checkbox({
  checked,
  'aria-labelledby': ariaLabelledBy,
  disabled = false,
  onChange,
  size = CheckboxSize.MEDIUM,
  dataTestAttrs = {},
}: CheckboxProps): JSX.Element {
  return (
    <MantineCheckbox
      checked={checked}
      aria-labelledby={ariaLabelledBy}
      disabled={disabled}
      onChange={onChange}
      size={size === CheckboxSize.SMALL ? 'sm' : 'md'}
      readOnly={!onChange}
      {...getTestProps(dataTestAttrs)}
    />
  );
}
